"use client";

import React from "react";
import { ArrowRight, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WelcomeToBlueElegance() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="38793" id="liquidity-for-your-land" ref={ref} className="relative w-full overflow-hidden dark bg-background py-20 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col-reverse gap-12 lg:flex-row lg:items-center lg:gap-20">
          {}
          <div className={`flex flex-col items-start lg:w-[55%] transition-all duration-1000 ease-out ${isVisible ? "translate-x-0 opacity-100" : "-translate-x-12 opacity-0"}`}>
            <div className="mb-6 inline-flex items-center gap-2 rounded-sm border border-primary/20 bg-secondary/40 px-3 py-1 text-sm font-medium text-primary">
              <Sparkles className="h-4 w-4" />
              <span>NATIONWIDE LAND BUYERS</span>
            </div>

            <h1 className="font-sans text-5xl font-extrabold leading-[1.05] tracking-tighter text-transparent bg-clip-text bg-gradient-to-b from-white to-muted-foreground sm:text-6xl md:text-7xl lg:text-9xl">
              NATIONWIDE <br />
              <span className="text-white">CASH OFFERS</span>
            </h1>

            <p className="mt-8 max-w-2xl font-mono text-lg leading-[1.8] text-muted-foreground md:text-xl">
              No Fees. No Commissions. No Hassle. Brentwood Enterprises provides
              direct liquidity for your vacant land with quick closes and
              transparent valuations. Sell your property on your terms today.
            </p>

            <div className="mt-10 flex flex-wrap gap-4">
              <Button asChild size="lg" className="h-14 rounded-sm px-8 text-base font-bold shadow-lg shadow-primary/10 transition-transform hover:scale-105 bg-primary text-primary-foreground">
                <Link to="/SellYourLandPage">
                  Start Your Offer
                  <ArrowRight className="ml-2 h-4 w-4" />
                </Link>
              </Button>

              <Button asChild variant="ghost" size="lg" className="h-14 rounded-sm px-8 text-base text-foreground border border-white/10 hover:bg-secondary/50">
                <Link to="/HomePage">How It Works</Link>
              </Button>
            </div>
          </div>

          {}
          <div className={`relative flex items-center justify-center lg:w-[45%] transition-all duration-1000 ease-out delay-300 ${isVisible ? "scale-100 opacity-100" : "scale-95 opacity-0"}`}>
            {}
            <div className="absolute -right-4 top-1/2 -z-10 h-[120%] w-[120%] -translate-y-1/2 translate-x-10 scale-90 rounded-full bg-secondary/20 blur-3xl opacity-40" />
            
            {}
            <div className="absolute -bottom-10 -left-10 -z-10 h-40 w-40 rounded-full bg-primary/10 blur-2xl" />

            <div className="relative">
              <div className="absolute -inset-1 rounded-sm bg-gradient-to-br from-white/10 to-transparent opacity-30 blur-sm" />
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1610811/img/land-topography.png" alt="Nationwide Land Topography" className="relative z-10 aspect-[4/5] w-full max-w-md rounded-sm border border-white/10 backdrop-blur-md object-cover shadow-2xl shadow-black/50" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}